import { ErrorState, LoadingState } from '@dreamtree-org/twreact-ui';

/**
 * Loading / error / content switch for a useQuery result.
 *   <QueryState query={q} skeleton="table">{(data) => <Table data={data} … />}</QueryState>
 * `skeleton` shapes the loading state like the content: table | cards | stats | detail.
 */
export default function QueryState({ query, children, loadingText = 'Loading…', skeleton = 'detail' }) {
  if (query.error) {
    return <ErrorState title="Could not load" description={query.error} onRetry={query.reload || undefined} retryLabel="Try again" />;
  }
  if (query.loading && query.data === undefined) return <LoadingState variant={skeleton} label={loadingText} />;
  return children(query.data);
}
